import { StoreError } from '@/types/storeError.interface';
import { IApplication, IAuthorization, IndexedAuthorizations } from '@/typings';
import {
  createStoreSlice as createSlice,
  type PayloadAction,
} from '@/store/core';
import { RootState } from '../store';

interface AuthorizationState {
  loading: boolean;
  error: StoreError | null;
  authorizations: IndexedAuthorizations;
}

const initialState: AuthorizationState = {
  authorizations: {},
  loading: false,
  error: null,
};

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    authorizationLoading: state => {
      state.loading = true;
    },
    fetchAuthorizationSuccess: (
      state,
      action: PayloadAction<{
        applicationId: IApplication['id'];
        authorization: IAuthorization;
      }>,
    ) => {
      state.loading = false;
      state.error = null;
      state.authorizations[action.payload.applicationId] = {
        ...state.authorizations?.[action.payload.applicationId],
        ...action.payload.authorization,
      };
    },
    fetchAuthorizationError: (state, action: PayloadAction<StoreError>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  authorizationLoading,
  fetchAuthorizationSuccess,
  fetchAuthorizationError,
} = authorizationSlice.actions;

export const selectAuthorization = (state: RootState) =>
  state[authorizationSlice.name] as typeof initialState;
